export const MENSAJE_LEGAJO_BLOQUEADO = "Su legajo se encuentra bloqueado. Por favor, comuníquese con su responsable técnico y/o la autoridad de aplicación.";
